import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "trans",
  "use": "trans-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"trans\"><path fill=\"#5BCEFA\" d=\"M0 27c0 2.209 1.791 4 4 4h28c2.209 0 4-1.791 4-4v-1.3H0V27z\" /><path fill=\"#F5A9B8\" d=\"M.026 20.5L0 25.8h36v-5.3z\" /><path fill=\"#EEE\" d=\"M0 15.3h36v5.3H0z\" /><path fill=\"#F5A9B8\" d=\"M0 9.902h36V15.4H0z\" /><path fill=\"#5BCEFA\" d=\"M36 9c0-2.209-1.791-4-4-4H4C1.791 5 0 6.791 0 9v1.2h36V9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol